import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import { Box, ButtonProps } from "@mui/material";
import Button from "@mui/material/Button";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useTranslation } from "react-i18next";

export interface Props {
  onSelect?: (key: string) => void;
  items: { key: string; label: string }[];
  label?: string;
  color?: ButtonProps["color"];
  variant?: "text" | "outlined" | "primary";
  fullWidth?: boolean;
  selected?: string[];
}

export const AddMenu = ({
  onSelect,
  items,
  label,
  color,
  variant,
  fullWidth,
  selected,
}: Props) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const { t } = useTranslation();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        onClick={handleClick}
        size="small"
        color={color}
        variant={variant}
        fullWidth={fullWidth}
        data-testid="add-menu"
        endIcon={<MoreVertIcon fontSize="small" />}
      >
        {t(label || "fundamentals.addMenu.title")}
      </Button>
      <Menu
        id="customized-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {items.length === 0 && (
          <MenuItem key="nothing" disabled>
            {t("fundamentals.addMenu.noItems")}
          </MenuItem>
        )}
        {items.map(({ key, label }) => {
          const isSelected = Boolean(selected?.includes(key));

          return (
            <MenuItem
              key={key}
              data-testid={`add-menu-item-${key}`}
              onClick={() => {
                if (onSelect) {
                  onSelect(key);
                }
              }}
              selected={isSelected}
            >
              <Box display="flex" gap={3}>
                <Checkbox checked={isSelected} sx={{ padding: 0 }} />
                <Typography variant="body3">{label}</Typography>
              </Box>
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};
